import { useState } from 'react'

const PORTAL_URL = import.meta.env.VITE_PORTAL_URL || 'https://app.zolym.com'
const ADMIN_URL = import.meta.env.VITE_ADMIN_URL || 'https://admin.zolym.com'

const NAV_LINKS = ['Platform', 'Apps', 'Pricing', 'Docs']

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <nav style={{
      position: 'sticky', top: 0, zIndex: 20,
      background: 'rgba(247,247,245,0.92)', backdropFilter: 'blur(12px)',
      borderBottom: '1px solid var(--border)',
    }}>
      <div className="wrap" style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        height: 64,
      }}>
        {/* Logo */}
        <a href="/" style={{ fontFamily: 'Jost', fontWeight: 300, fontSize: 18, letterSpacing: '0.28em', textDecoration: 'none', color: 'inherit', flexShrink: 0 }}>
          <span style={{ color: 'var(--accent)' }}>Z</span>OLYM
        </a>

        {/* Desktop nav */}
        <div className="nav-links-desktop">
          {NAV_LINKS.map(l => (
            <span key={l} style={{ cursor: 'pointer', fontSize: 14, color: '#4a4a50' }}>{l}</span>
          ))}
        </div>

        {/* Desktop actions */}
        <div className="nav-actions-desktop">
          <a href={PORTAL_URL} style={{ fontSize: 14, color: 'var(--body)', textDecoration: 'none' }}>Sign in</a>
          <a href={PORTAL_URL} className="btn" style={{ textDecoration: 'none' }}>
            Open app
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
          </a>
          <a href={ADMIN_URL} style={{ fontSize: 12, color: 'var(--faint)', textDecoration: 'none', fontFamily: 'JetBrains Mono, monospace' }}>Admin</a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="nav-hamburger"
          onClick={() => setMobileOpen(o => !o)}
          aria-label="Toggle menu"
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            padding: 8, display: 'flex', flexDirection: 'column', gap: 5,
          }}
        >
          <span style={{ display: 'block', width: 22, height: 1.5, background: mobileOpen ? 'transparent' : 'var(--ink)', transition: 'all 0.2s' }} />
          <span style={{ display: 'block', width: 22, height: 1.5, background: 'var(--ink)', transform: mobileOpen ? 'rotate(45deg) translate(4px, 4px)' : 'none', transition: 'all 0.2s' }} />
          <span style={{ display: 'block', width: 22, height: 1.5, background: 'var(--ink)', transform: mobileOpen ? 'rotate(-45deg) translate(4px, -4px)' : 'none', transition: 'all 0.2s' }} />
        </button>
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="nav-mobile-drawer">
          {NAV_LINKS.map(l => (
            <span key={l} style={{ display: 'block', padding: '14px 0', fontSize: 16, color: 'var(--ink)', cursor: 'pointer', borderBottom: '1px solid var(--border)' }}>
              {l}
            </span>
          ))}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, paddingTop: 20 }}>
            <a href={PORTAL_URL} className="btn lg" style={{ textDecoration: 'none', justifyContent: 'center' }}>
              Open app
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
            </a>
            <a href={PORTAL_URL} style={{ fontSize: 14, color: 'var(--body)', textDecoration: 'none', textAlign: 'center' }}>Sign in</a>
          </div>
        </div>
      )}
    </nav>
  )
}
